import Cache from "src/core/common/cache";

const formsCache = new Cache();

export default formsCache;
